import { useEffect, useState } from 'react';

export const useParentWidth = parentRef => {
    const [parentWidth, setParentWidth] = useState(Infinity);

    useEffect(() => {
        if (!parentRef.current) {
            return;
        }
        const { clientWidth } = parentRef.current;
        /**
         * left and right margins ~ 24px
         */
        setParentWidth(clientWidth - 48);
    }, [parentRef.current]);

    return parentWidth;
};
